'use strict';
define([], function () {
    return {
        templateUrl: 'app/modules/seospider/exam/analysis/description/table.html',
        bindings: {
            pages: '=',
            type: '<',
        },
        controller: ['$scope', '$rootScope', '$window', '$translate', function ($scope, $rootScope, $window, $translate) {
            var vm = $scope;
            $scope.$watch('$ctrl.pages', function (pages) {
                vm.pages = pages;
            });

            if (!vm.pages) {
                vm.pages = [];
            }

            vm.openDetail = openDetail;
            vm.evalOccurences = evalOccurences;
            vm.evalLength = evalLength;

            function evalOccurences(score) {
                switch (parseInt(score) || 0) {
                    case 1:
                        return 'green-text';
                    case 0:
                        return 'red-text';
                    default:
                        return 'text-darken-1 orange-text';
                }
            }

            function evalLength(len) {
                len = parseInt(len) || 0;
                if (len > 160)
                    return 'red-text';
                if (len >50&&len<=160)
                    return 'green-text';
                if (len >=20&&len<=50)
                    return 'text-darken-1 orange-text';
                return 'red-text';
            }

            function openDetail(page) {
                var url = new URL(page.url);
                var pathname = url.pathname.length ? url.pathname : '/';

                $rootScope.$emit('openToolbarDetail', {
                    list: page.list,
                    templateType: 'multipleDescription',
                    element: 'meta name="description"',
                    label: $translate.instant('seospider.description.multiple'),
                    placeholder: $translate.instant('seospider.search.multiple', {'pathname': pathname})
                });

                $rootScope.$on('languageChanged', function () {
                    $rootScope.$emit('openToolbarDetail', {
                            list: page.duplicated,
                            templateType: 'duplicatedDescription',
                            element: 'meta name="description"',
                            label: $translate.instant('seospider.description.multiple'),
                            placeholder: $translate.instant('seospider.search.multiple', {'pathname': pathname})
                        }
                    );
                });

            }
        }]
    };
});

